

























































import Vue from "vue"
import { companyService, ICompanyService } from "@/model/service/company/company-service"
import { IOfficeService, officeService } from "@/model/service/office/office-service"
import { employeeService, IEmployeeService } from "@/model/service/employee/employee-service"
import { Company } from "@/model/entity/company/company"
import { Office } from "@/model/entity/office/office"
import Datatable, { DatatableOptions, IDatatable } from "@/components/datatable/Datatable.vue"
import { DpdProduct } from "@/model/new-parcel-model/dpd-product/dpd-product"
import { plainToClass } from "class-transformer"
import CompanyEditor from "@/components/user-administration/CompanyEditor.vue"
import { ICompanyOffices } from "@/components/user-administration/CompanyOffices.vue"

export interface IUserAdministrationData {
  items: any
  companyService: ICompanyService
  officeService: IOfficeService
  employeeService: IEmployeeService
  options: DatatableOptions
  fields: any
  products: DpdProduct[]
  editorVisible: boolean
  editedCompany: Company
  valid: boolean
  hint: string
  initialCompanyStatus: string
}

export default Vue.extend({
  components: {
    Datatable,
    CompanyEditor
  },
  data(): IUserAdministrationData {
    return {
      options: {
        operations: {}
      },
      companyService: companyService,
      officeService: officeService,
      employeeService: employeeService,
      fields: Company.getFieldDescriptionList(),
      items: [] as any,
      products: [],
      editorVisible: false,
      editedCompany: new Company(),
      valid: false,
      hint: "",
      initialCompanyStatus: ""
    }
  },
  methods: {
    resetCompanyAndEditor() {
      this.editedCompany = new Company()
      const companyEditor = this.$refs.companyEditor as Vue
      const companyOffices = companyEditor.$refs.companyOffices as ICompanyOffices
      this.$nextTick(() => companyOffices.resetOffices())
    },
    openEditor() {
      this.editorVisible = true
    },
    editCompany(company: Company) {
      this.editedCompany = JSON.parse(JSON.stringify(company))
      this.initialCompanyStatus = company.status
      this.openEditor()
    },
    addCompany() {
      this.editedCompany = new Company()
      this.openEditor()
    },
    saveCompany() {
      const vm = this
      vm.startLoad()
      vm.companyService
        .createOrModify(vm.editedCompany)
        .then(companyResult => {
          const persistedCompany = companyResult.data
          const companyEditor = vm.$refs.companyEditor as Vue
          const companyOffices = companyEditor.$refs.companyOffices as ICompanyOffices
          const officeList = companyOffices.offices.filter(office => !exists(office.id))
          if (officeList.length > 0) {
            vm.officeService
              .saveBulk(
                officeList.map(office => {
                  office.company = persistedCompany
                  return office
                })
              )
              .then(
                officeListResult => {
                  const officeList = officeListResult.data
                  let processed = 0
                  officeList.forEach((office: Office, index: number) => {
                    if (office.id === vm.$store.getters.loggedUser.office.id) {
                      vm.$i18n.locale = office.lang.toLowerCase()
                      vm.$store.state.authenticatedEmployee.office = office
                    }

                    const employeeList = companyOffices.officeEmployees[index].employees.filter(
                      employee => !exists(employee.id)
                    )
                    if (employeeList.length > 0) {
                      vm.employeeService
                        .saveBulk(
                          employeeList.map(employee => {
                            employee.office = office
                            return employee
                          })
                        )
                        .then(() => {
                          processed++
                          if (processed === officeList.length) {
                            vm.endLoad()
                            vm.editorVisible = false
                            vm.getData()
                          }
                        })
                        .catch(error => {
                          vm.endLoad()
                          vm.$error(error.message)
                        })
                    } else {
                      vm.endLoad()
                      vm.editorVisible = false
                      vm.getData()
                    }
                  })
                },
                response => {
                  if (response.data && response.data.message) {
                    vm.$error(response.data.message)
                  } else {
                    vm.$error(response)
                  }
                  vm.endLoad()
                }
              )
              .catch(error => {
                vm.endLoad()
                vm.$error(error.message)
              })
          } else {
            vm.endLoad()
            vm.editorVisible = false
            vm.getData()
          }
        })
        .catch(error => {
          vm.endLoad()
          vm.$error(error.data.message)
        })
    },
    getData() {
      const iDatatable = this.$refs.datatable as IDatatable
      iDatatable.refreshData()
    }
  }
})
